import { useEffect } from 'react';

import useSetVariantIdAttribute from 'hooks/useSetVariantIdAttribute';
import useThemeStyle from 'hooks/useThemeStyle';
import { usePageData } from 'state/pageData';
import { useSession } from 'state/session';
import { loadWidgetData } from 'state/widget/actions';
import { useWidget } from 'state/widget/context';

interface WidgetOverrides {
  variantId?: string;
}

export interface WidgetLoaderProps {
  children?: React.ReactNode;
  overrides?: WidgetOverrides;
}

const WidgetLoader: React.FC<WidgetLoaderProps> = ({ children, overrides }) => {
  const { variantId } = overrides ?? {};

  const {
    dispatch,
    state: { status },
  } = useWidget();

  useSetVariantIdAttribute();

  // TODO - this doesn't seem to belong here.  Component is concerned with fetching
  // widget data, not rendering themes
  useThemeStyle();

  const { title, url, widgetId } = usePageData();
  const { sessionId } = useSession();

  useEffect(() => {
    if (status === undefined) {
      loadWidgetData(dispatch, widgetId, {
        sessionId,
        url,
        variantIdOverride: variantId,
        q: title,
      });
    }
  }, [dispatch, sessionId, status, title, url, variantId, widgetId]);

  if (status !== 'success') {
    return null;
  }

  return <>{children}</>;
};

export default WidgetLoader;
